var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoRevendeurSansTexte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 51.766,
    height: 51.766,
    viewBox: "1.500 -5.884 51.766 51.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 48.766,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto_revendeur",
    "data-name": "picto revendeur",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 43.956,
    height: 0.906,
    transform: "translate(4.634 38.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_98",
    "data-name": "Groupe 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_97",
    "data-name": "Groupe 97",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_166",
    "data-name": "Trac\\xE9 166",
    d: "M13.027,40,5.422,27.126A69.336,69.336,0,0,1,1.363,19.1a12.235,12.235,0,0,1-.677-2.092L.3,15.3A12.207,12.207,0,0,1,.485,9.207,12.085,12.085,0,0,1,2.964,4.646l.174-.2a12.123,12.123,0,0,1,4-3.042l.484-.229A12.119,12.119,0,0,1,12.968,0l1.35.014a14.126,14.126,0,0,1,4.545.8,12.25,12.25,0,0,1,4.819,3.136,7.577,7.577,0,0,1,1.9,3.637l.071.337a19.3,19.3,0,0,1,.133,7.313,31.2,31.2,0,0,1-1.556,5.7,32.57,32.57,0,0,1-1.857,4.049L20.506,28.42ZM12.838.906A11.336,11.336,0,0,0,8.011,1.991l-.484.229a11.222,11.222,0,0,0-3.7,2.816l-.174.2a11.2,11.2,0,0,0-2.3,4.222,11.308,11.308,0,0,0-.171,5.64l.387,1.712A11.3,11.3,0,0,0,2.2,18.749,68.53,68.53,0,0,0,6.2,26.666l6.861,11.612,6.666-10.32,1.851-3.4a31.73,31.73,0,0,0,1.8-3.937A30.337,30.337,0,0,0,24.9,15.086a18.42,18.42,0,0,0-.127-6.972L24.7,7.777a6.675,6.675,0,0,0-1.675-3.2,11.324,11.324,0,0,0-4.461-2.9,13.165,13.165,0,0,0-4.254-.75L12.958.907h-.12",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_167",
    "data-name": "Trac\\xE9 167",
    d: "M14.356,18.417A5.547,5.547,0,1,1,19.9,12.87a5.553,5.553,0,0,1-5.546,5.547m0-10.189A4.642,4.642,0,1,0,19,12.87a4.647,4.647,0,0,0-4.641-4.642",
    transform: "translate(-0.835 -0.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_168",
    "data-name": "Trac\\xE9 168",
    d: "M51.42,17.2l-23.436-.4L28,15.892l21.743.377-3.251-5.063H28.609V10.3H46.986Z",
    transform: "translate(-2.654 -0.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 6.348,
    height: 0.905,
    transform: "translate(30.128 15.84) rotate(-80.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_169",
    "data-name": "Trac\\xE9 169",
    d: "M36.659,23.622a4.585,4.585,0,0,1-2.773-.878l.536-.73c1.785,1.311,4.08.424,4.806.085V16.552L38.4,11.017l.9-.132.832,5.6,0,6.156-.23.13a7.246,7.246,0,0,1-3.243.849",
    transform: "translate(-3.214 -1.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 0.905,
    height: 6.76,
    transform: "translate(39.256 9.847) rotate(-24.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_170",
    "data-name": "Trac\\xE9 170",
    d: "M30.211,24.244a4.688,4.688,0,0,1-3-.932l-.16-.141.128-4.222.905.027-.114,3.774c.511.333,2.222,1.179,5.082-.07V17.146h.905v6.113l-.261.122a8.185,8.185,0,0,1-3.487.863",
    transform: "translate(-2.566 -1.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_171",
    "data-name": "Trac\\xE9 171",
    d: "M43.051,24.291a3.936,3.936,0,0,1-2.857-1.226l.64-.641c1.875,1.874,4.1.537,4.723.1V17.325h.905v5.634L46.3,23.1a5.431,5.431,0,0,1-3.245,1.2",
    transform: "translate(-3.812 -1.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_172",
    "data-name": "Trac\\xE9 172",
    d: "M49.182,24.5a3.786,3.786,0,0,1-2.772-1.078l.641-.64c1.565,1.565,4.262.433,5.062.043V17.67h.905v5.692l-.229.13a8.225,8.225,0,0,1-3.607,1",
    transform: "translate(-4.401 -1.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 0.905,
    height: 16.641,
    transform: "translate(44.854 22.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 0.905,
    height: 9.063,
    transform: "translate(18.559 30.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_173",
    "data-name": "Trac\\xE9 173",
    d: "M25.588,42.006h-.905V28.376H44.5V42H43.6V29.282H25.588Z",
    transform: "translate(-2.341 -2.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 0.905,
    height: 13.519,
    transform: "translate(34.53 26.031)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoRevendeurSansTexte);
export default __webpack_public_path__ + "static/media/picto_revendeur_sans_texte.10e68d9118ac15da91ae1eb49e04c3fa.svg";
export { ForwardRef as ReactComponent };